<template>
  <section id="contact" class="section module-contract">
    <div class="section-container">
      <div data-aos="opacity-only">
        <div class="contract_wrapper">
          <h2 class="contact-title">{{ title }}</h2>
          <h2 class="contact-title-mobile">{{ titleSplit[0] }}<br/>{{ titleSplit[1] }}</h2>
          <a v-if="email" class="learn-more-btn light" :href="`mailto:${email}`">
            {{ btnTxt }}
            <div class="circle"> </div>
          </a>

          <div v-else class="learn-more-btn light" @click="toContact">
            {{ btnTxt }}
            <div class="circle"> </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "ContactModule",
  props: {
    btnTxt: {
      type: String,
      default: "了解更多"
    },
    email: {
      type: String,
      default: ""
    },
    title:{
      type: String,
      default: "联系我们，获取更多方案服务"
    }
  },
  computed: {
    titleSplit(){
      return this.title.split('，');
    }
  },
  methods: {
    toContact() {
      this.$router.push({ path: '/contact' });
    }
  }
}
</script>
<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .section {
    padding: 100px 0;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      // padding: 0 40px;
    }
  }

  .module-contract {
    background: linear-gradient(to top right,
        #0049ff,
        #096efe 50%,
        #2cdaf5); // 带透明度

    color: #fff;
    text-align: center;

    .contract_wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .contact-title {
      font-size: 40px;
      color: rgba(255, 255, 255, 0.9);
      font-weight: bold;
    }
    .contact-title-mobile{
      display: none;
    }
  }

  .learn-more-btn {
    cursor: pointer;
    width: 136px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 16px;
    background: #0248ff;
    border-radius: 50px;
    color: #fff;
    text-decoration: none;

    .circle {
      margin-left: 24px;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      background: url('../static/home/circle_arrow_right.png');
    }
  }

  .light {
    background: #fff;
    color: #0248ff;

    .circle {
      background: url('../static/home/circle_arrow_right_light.png');
    }
  }

  .light:hover {
    background: #0248ff;
    color: #fff;

    .circle {
      background: url('../static/home/circle_arrow_right.png');
    }
  }
}

// mobile
@media (max-width: 750px) {
  .section {
    padding: 50px 0;

    .section-container {
      padding: 0 24px;
      width: 100%;
    }
  }

  .module-contract {
    background: linear-gradient(to top right,
        #0049ff,
        #096efe 50%,
        #2cdaf5); // 带透明度

    color: #fff;
    text-align: center;
    padding: 50px 0!important;

    .contract_wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .contact-title {
      display: none;
      font-size: 40px;
      color: rgba(255, 255, 255, 0.9);
      font-weight: bold;
    }
    .contact-title-mobile {
      display: block;
      text-align: left;
      font-size: 20px;
      color: rgba(255, 255, 255, 0.9);
      font-weight: bold;
    }
  }

  .learn-more-btn {
    cursor: pointer;
    width: 88px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 12px;
    background: #0248ff;
    border-radius: 50px;
    color: #fff;
    text-decoration: none;

    .circle {
      margin-left: 12px;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background: url('../static/home/circle_arrow_right.png');
      background-size: 100% 100%;
    }
  }

  .light {
    background: #fff;
    color: #0248ff;

    .circle {
      background: url('../static/home/circle_arrow_right_light.png');
      background-size: 100% 100%;
    }
  }
}


/* 1. 自定义纯透明度动画样式（scoped 不影响，因为属性选择器能匹配） */
[data-aos="opacity-only"] {
  opacity: 0;
  /* 复用 AOS 的全局变量，和 data-aos-duration 联动 */
  transition: opacity var(--aos-duration) ease var(--aos-delay);
}

.aos-animate[data-aos="opacity-only"] {
  opacity: 1;
}
</style>